import React from 'react';
import styles from './_style.module.scss';

const QuoteBuilderLayout = ({ drawing, children }) => {
  return (
    <div className={styles.layoutContainer}>
      <div className={styles.imageSection}>
        {drawing.image !== undefined && (
          <img
            src={drawing.image.three_d_image_url}
            className={styles.previewImage}
            alt="3D Preview"
          />
        )}
      </div>
      <div className={styles.header}>
        <h3 className={styles.title}>{t('quote_builder_widget.get_a_quote')}</h3>
      </div>
      <div className={styles.formSection}>
        {children}
      </div>
    </div>
  );
};

export default QuoteBuilderLayout;
